import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { UkraineMap } from 'components/UkraineMap'
import { Key } from 'components/Chart_Key'
import ContentGrid from 'components/ContentGrid'
import Column from 'components/Column'
import { useEffectOnce, useWindowSize } from 'usehooks-ts'
import { Scroller } from 'components/Scroller'
import { MicroFrontendProps } from 'Types/MicroFrontendProps'
import { UkraineMapAnimated } from 'components/UkraineMapAnimated'

/*



*/
const Bombs = {
  february: '2022-02-01-2022-03-31.json',
  april: '2022-04-01-2022-04-30.json',
  may: '2022-05-01-2022-05-31.json',
  june: '2022-06-01-2022-06-30.json',
}
const Controlled = {
  february: '2022-03-31-ru-controlled.json',
  april: '2022-05-01-ru-cotrolled.json',
  may: '2022-05-31-ru-controlled.json',
  june: '2022-06-27-ru-controlled.json',
}
const Advances = {
  february: '2022-03-31-ru-advances.json',
  april: '2022-05-01-ru-advances.json',
  may: '2022-05-31-ru-advances.json',
  june: '2022-06-27-ru-advances.json',
}

const MapLabels: { [key: string]: MapLabelType[] } = {
  february: [
    {
      label: 'Kiew',
      pos: [30.546650063853413, 50.45542322596882],
      offset: 'top',
    },
    {
      label: 'Mariupol',
      pos: [37.57644210219802, 47.11237675276624],
      offset: 'bottom',
    },
    {
      label: 'Charkiw',
      pos: [36.254042533987096, 49.98604663724994],
      offset: 'top',
    },
    // {
    //   label: 'Odessa',
    //   pos: [30.714881650640454, 46.463001892414724],
    //   offset: 'top-left',
    // },
  ],
  april: [
    // {
    //   label: 'Kiew',
    //   pos: [30.546650063853413, 50.45542322596882],
    //   offset: 'bottom',
    // },

    {
      label: 'Charkiw',
      pos: [36.254042533987096, 49.98604663724994],
      offset: 'top',
    },
    {
      label: 'Sjewjerodonezk',
      pos: [38.48660925248119, 48.948737034011685],
      offset: 'bottom-left',
    },
    {
      label: 'Wisar',
      pos: [30.3705, 50.3891],
      offset: 'top',
    },
  ],
  may: [
    // {
    //   label: 'Sjewjerodonezk',
    //   pos: [38.48660925248119, 48.948737034011685],
    //   offset: 'bottom-left',
    // },
    {
      label: 'Kiew',
      pos: [30.546650063853413, 50.45542322596882],
      offset: 'bottom',
    },

    {
      label: 'Charkiw',
      pos: [36.254042533987096, 49.98604663724994],
      offset: 'top',
    },

    {
      label: 'Mariupol',
      pos: [37.57644210219802, 47.11237675276624],
      offset: 'bottom',
    },
  ],
  june: [
    {
      label: 'Kiew',
      pos: [30.546650063853413, 50.45542322596882],
      offset: 'bottom',
    },
    {
      label: 'Sjewjerodonezk',
      pos: [38.48660925248119, 48.948737034011685],
      offset: 'top-left',
    },
    // {
    //   label: 'Charkiw',
    //   pos: [36.254042533987096, 49.98604663724994],
    //   offset: 'top',
    // },
    {
      label: 'Mykolajiw',
      pos: [31.989143397964387, 46.96397821283287],
      offset: 'top-left',
    },
  ],
}
/*



*/
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = {
    time: 'february',
    title: 'Title from MF-Properties',
    sub: 'Mai',
  },
}): ReactElement => {
  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  useEffectOnce(() => {
    setHeight(window.innerHeight)
  })
  const RegionsLabels: { [key: string]: RegionLabelType[] } = {
    february: [
      {
        pos: [29.873570250437233, 50.463679269187345] as [number, number],
        r: [5, 5],
      },
      {
        pos: [31.007268969849534, 50.60854772139682] as [number, number],
        r: [2, 2],
      },
      {
        pos: [23.4, 49.93] as [number, number],
        r: [2, 2],
      },
    ],
    april: [
      {
        pos: [30.3705, 50.3891] as [number, number],
        r: [8, 8],
      },

      {
        pos: [36.2, 50] as [number, number],
        r: [5, 5],
      },
      {
        pos: [26.729586971302293, 50.07432931807697] as [number, number],
        r: [17, 9],
      },
      {
        pos: [36.237312446384024, 49.972023820000096] as [number, number],
        r: [25, 25],
      },
    ],
    may: [
      {
        pos: [38, 48.7] as [number, number],
        r: [6, 6],
      },
      {
        pos: [36.2, 47.8] as [number, number],
        r: [5, 5],
      },
      {
        pos: [36.26262365369958, 50] as [number, number],
        r: [4, 4],
      },
    ],
    june: [
      {
        pos: [38.2, 48.8] as [number, number],
        r: [5, 5],
      },
      {
        pos: [32.5, 47] as [number, number],
        r: [5, 5],
      },
      {
        pos: [38, 48.5] as [number, number],
        r: [5, 5],
      },
    ],
  }
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const TimeStrings = {
    february: 'Februar – März',
    april: 'April',
    may: 'Mai',
    june: 'Juni (bis zum 24.)',
  }
  const TimeStringsKey = {
    february: 'Ende März',
    april: 'Ende April',
    may: 'Ende Mai',
    june: 'am 24. Juni',
  }
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {
        <ContentGrid>
          <Column wide>
            {/* <UkraineMapAnimated /> */}
            <Scroller
              defaultDistance={height}
              front={[
                <FrontElement>
                  <Title>Der gescheiterte «Enthauptungsschlag»</Title>
                  <TimeTitle>Februar &mdash; März</TimeTitle>

                  <AttackCounter
                    air={146}
                    artillery={782}
                    colorMode={colorMode}
                  />
                </FrontElement>,
                <FrontElement>
                  Als die russischen Streitkräfte am{' '}
                  <b>24. Februar die Ukraine-Invasion begannen</b>, führten sie
                  eine Luftlandeoperation am Flughafen Kiew-Hostomel durch.
                  Zahlreiche <b>Raketenangriffe</b> (
                  <OrangeMarker colorMode={colorMode} />) sollten diese Aktion
                  unterstützen , vereinzelt kam es auch zu <b>Luftschlägen</b> (
                  <BlueMarker colorMode={colorMode} />
                  ). Doch der «Enthauptungsschlag», wie ihn Militäranalyst
                  Masuhr nennt, scheiterte nach wochenlangen Angriffen, durch
                  die Kiew eingeschlossen werden sollte. Ende März gaben die
                  russischen Truppen auf und zogen sich zurück. Die Ukrainer
                  brachten die Vororte Hostomel, Butscha und Irpin wieder unter
                  ihre Kontrolle.
                </FrontElement>,
                <FrontElement>
                  Gleichzeitig gelang es russischen Truppen, bis in{' '}
                  <b>östliche Vororte Kiews</b> vorzudringen – wiederum
                  unterstützt durch Feuerkraft. Auch diese Angriffe scheiterten.
                </FrontElement>,
                <FrontElement>
                  Auffallend sind die vielen Angriffe im Westen der Ukraine.
                  Gemäss Masuhr nahmen die Russen zu Beginn der Invasion mit
                  ihren Schlägen strategische wichtige Einrichtungen ins Visier.
                  Am 13. März kam es zu einem Raketenangriff auf eine{' '}
                  <b>Militärbasis in Jaworiw</b> – wobei bis zu 40 ukrainische
                  Soldaten getötet und mehr als 130 verletzt wurden.
                </FrontElement>,
                <FrontElement distance={height * 1.2}>
                  <Title>Die Verlagerung in den Osten</Title>
                  <TimeTitle>April</TimeTitle>
                  <AttackCounter
                    air={56}
                    artillery={786}
                    colorMode={colorMode}
                  />
                </FrontElement>,
                <FrontElement>
                  Der Rückgang der Angriffe im Norden verdeutlicht, dass der
                  «Enthauptungsschlag» gescheitert war. Um die{' '}
                  <b>Hauptstadt Kiew</b> kam es im April kaum mehr zu Angriffen
                  der Russen, die sich inzwischen zurückgezogen hatten.
                </FrontElement>,
                <FrontElement>
                  Stattdessen formierte sich die russische Armee neu und
                  konzentrierte ihre Kräfte auf den Osten. Bereits in den ersten
                  Kriegstagen hatten die Russen versucht, <b>Charkiw</b>{' '}
                  einzunehmen – waren aber wiederholt gescheitert. In der Folge
                  wollten die Angreifer die Stadt an der Grenze zu Russland im
                  Osten umgehen. Davon zeugten die vielen Artillerieschläge. Das
                  Ziel dieser Strategie war, die ukrainischen Truppen an der
                  Donbass-Front einzukreisen. Das ist trotz massiver Feuerkraft
                  jedoch bis heute nicht gelungen.
                </FrontElement>,
                <FrontElement>
                  Nach wie vor kam es in dieser Phase des Kriegs vereinzelt zu
                  Schlägen auf <b>Ziele im Westen</b> der Ukraine. In der Nacht
                  vom 15. auf den 16. April zerstörten die Russen mit
                  Langstreckenraketen die ukrainische{' '}
                  <b>Rüstungsfabrik Wisar</b>. In diesem Werk waren die
                  Antischiffsraketen hergestellt worden, mit denen das
                  ukrainische Militär das russische Schiff Moskwa versenkt
                  hatte.
                </FrontElement>,
                <FrontElement distance={height * 1.2}>
                  <Title>Der Granaten- und Bombenhagel wird intensiver</Title>
                  <TimeTitle>Mai</TimeTitle>
                  <AttackCounter
                    air={148}
                    artillery={1080}
                    colorMode={colorMode}
                  />
                </FrontElement>,
                <FrontElement>
                  Was sich bereits im April abgezeichnet hatte, bestätigte sich
                  im Mai: die neue Strategie der russischen Kriegsführung mit
                  der <b>Verlagerung in den Donbass</b>. Unter dem neuen
                  Oberbefehlshaber konzentrierten sich die Invasoren noch
                  stärker auf den Einsatz ihrer Artillerie. Nach wie vor bestand
                  der Plan, die ukrainischen Truppen grossflächig einzukreisen.
                  Der Beschuss mit Granaten und Raketen intensivierte sich
                  gegenüber dem Vormonat April deutlich. «Wir sehen in den Daten
                  im Mai, dass Russland diesen Krieg nicht mit Präzision führt,
                  sondern mit Volumen und Masse», sagt Analyst Masuhr. Der
                  Gegner solle zermürbt und abgenutzt werden. Diese Strategie
                  ist letztlich auch der Grund, warum Städte wie Mariupol und
                  Charkiw fast vollständig zerstört wurden von den Russen.
                </FrontElement>,
                <FrontElement>
                  <b>Nordwestlich von Mariupol</b> erhöhten die Russen
                  gleichzeitig die Zahl ihrer Luftschläge. Für Wissenschaftler
                  Masuhr war das ebenfalls ein Zeichen der neuen
                  Kommandostruktur, die es erlaubte, die Luftwaffe häufiger
                  einzusetzen.
                </FrontElement>,
                <FrontElement>
                  Im Mai drängten ukrainische Truppen in einer Gegenoffensive
                  das russische Militär zurück. Aus diesem Grund intensivierten
                  die Russen das Artilleriefeuer an der betreffenden
                  Kriegsfront.
                </FrontElement>,
                <FrontElement distance={height * 1.2}>
                  <Title>Der «Fleischwolf von Sjewjerodonezk»</Title>
                  <TimeTitle>Juni (bis zum 24.)</TimeTitle>
                  <AttackCounter
                    air={171}
                    artillery={1232}
                    colorMode={colorMode}
                  />
                </FrontElement>,
                <FrontElement>
                  Im <b>Donbass</b> hat sich der Frontverlauf seit Beginn der
                  Invasion kaum verändert. «Russland führt einen sehr statischen
                  Krieg», sagt Militäranalyst Masuhr. Und ist damit erfolgreich:
                  Am 24. Juni mussten die ukrainischen Truppen{' '}
                  <b>Sjewjerodonezk</b> aufgeben, nachdem die Stadt wochenlang
                  umkämpft war. In dieser Phase des Kriegs haben die Russen laut
                  Masuhr ihre Feuerkraft nochmals auf ein kleineres Gebiet
                  konzentriert – Analysten reden in diesem Zusammenhang auch vom
                  «Fleischwolf von Sjewjerodonezk». Damit sei aber das
                  Ambitionsniveau der russischen Kriegsziele nochmals gesenkt
                  worden, erklärt ETH-Wissenschaftler Masuhr, auch weil
                  vorherige ambitioniertere Einkreisungsversuche nicht
                  erfolgreich gewesen seien. Letztlich seien den russischen
                  Truppen jeweils nur sehr lokal begrenzte Umklammerungen der
                  ukrainischen Truppen gelungen.
                </FrontElement>,
                <FrontElement>
                  In der <b>Region Cherson</b> startete das ukrainische Militär
                  einen Gegenangriff. Zur Unterstützung der eigenen Bodentruppen
                  setzten die Russen daher vermehrt Artilleriefeuer ein.
                </FrontElement>,
                <FrontElement>
                  Zahlreiche russische Luftschläge bei der Stadt Sjewjerodonezk.
                </FrontElement>,
                <FrontElement distance={height * 1.2}>
                  <Title>Die Bilanz aus vier Monaten Krieg</Title>

                  <StyledBuildingCounter>
                    <BuildingText className='top'>
                      Seit Kriegsbeginn im Februar wurden mindestens
                    </BuildingText>{' '}
                    <BuildingElement>
                      <div className='icon'>
                        <img
                          src={require(colorMode === 'light'
                            ? '../../assets/icons_school.png'
                            : '../../assets/icons_school_dm.png')}
                        />
                      </div>
                      <div className='value'>62</div>
                      <div className='label'>Schulen</div>
                    </BuildingElement>
                    <BuildingElement>
                      <div className='icon'>
                        <img
                          src={require(colorMode === 'light'
                            ? '../../assets/icons_hospital.png'
                            : '../../assets/icons_hospital_dm.png')}
                        />
                      </div>
                      <div className='value'>40</div>
                      <div className='label'>Kranken&shy;häuser</div>
                    </BuildingElement>
                    <BuildingElement>
                      <div className='icon'>
                        <img
                          src={require(colorMode === 'light'
                            ? '../../assets/icons_kindergarten.png'
                            : '../../assets/icons_kindergarten_dm.png')}
                        />
                      </div>
                      <div className='value'>21</div>
                      <div className='label'>Kindergärten</div>
                    </BuildingElement>
                    <BuildingText className='bottom'>
                      {' '}
                      beschädigt oder zerstört.
                    </BuildingText>
                  </StyledBuildingCounter>
                </FrontElement>,
              ]}
              back={(index) => {
                let time = 'none'
                let step = 0
                let showlabel = false
                if (index <= 3) {
                  time = 'february'
                } else if (index <= 7) {
                  time = 'april'
                }
                if (index <= 3) {
                  step = index - 1
                  if (index > 0) showlabel = true
                } else if (index <= 7) {
                  step = index - 5
                  if (index > 4) showlabel = true
                } else if (index <= 11) {
                  time = 'may'
                  step = index - 9
                  if (index > 8) showlabel = true
                } else if (index > 11) {
                  time = 'june'
                  step = index - 13
                  if (index > 12) showlabel = true
                }
                // console.log(index, time, step)
                let bombs =
                  index === 16
                    ? require('../GeoJSON/civilbuildings.json')
                    : require('../GeoJSON/' + Bombs[time])
                return (
                  <>
                    <Column style={{ height: height + 'px' }}>
                      <MapWrapper className='MapWrapper'>
                        <Time>
                          {index === 16 ? 'Februar – Juni' : TimeStrings[time]}
                        </Time>

                        {bombs && (
                          <UkraineMap
                            height={height}
                            data={bombs}
                            russianControl={
                              index !== 16 &&
                              require('../GeoJSON/' + Controlled[time])
                            }
                            russianAdvance={
                              index !== 16 &&
                              require('../GeoJSON/' + Advances[time])
                            }
                            regionLabels={
                              showlabel &&
                              step < RegionsLabels[time].length &&
                              step >= 0
                                ? [RegionsLabels[time][step]]
                                : undefined
                            }
                            mapLabels={MapLabels[time]}
                            colorMode={colorMode}
                            index={index}
                          />
                        )}
                        {bombs && (
                          <KeyWrapper>
                            <Key
                              entries={
                                index === 16
                                  ? [
                                      {
                                        type: 'cross',
                                        label: (
                                          <>
                                            Beschädigte oder zerstörte Schulen,
                                            Kranken&shy;häuser und Kindergärten
                                          </>
                                        ),
                                        color: '#D3343F',
                                      },
                                    ]
                                  : [
                                      {
                                        type: 'circle',
                                        label:
                                          'Artillerie, Raketen (' +
                                          bombs.features.filter(
                                            (f: {
                                              properties: { event: string }
                                            }) =>
                                              !f.properties.event
                                                .toLowerCase()
                                                .includes('air')
                                          ).length +
                                          ')',
                                        color:
                                          colorMode === 'light'
                                            ? '#E16D00'
                                            : '#E16D00',
                                      },
                                      {
                                        type: 'circle',
                                        label:
                                          'Luftschläge (' +
                                          bombs.features.filter(
                                            (f: {
                                              properties: { event: string }
                                            }) =>
                                              f.properties.event
                                                .toLowerCase()
                                                .includes('air')
                                          ).length +
                                          ')',
                                        color:
                                          colorMode === 'light'
                                            ? '#202346'
                                            : '#378EBD',
                                      },
                                      {
                                        type: 'rect',
                                        label: (
                                          <>
                                            Von Russland kontrollierte Gebiete{' '}
                                            <span>{TimeStringsKey[time]}</span>
                                          </>
                                        ),
                                        color:
                                          colorMode === 'light'
                                            ? '#C8C8D1'
                                            : 'rgba(239, 236, 224,.4)',
                                      },
                                      {
                                        type: 'rect-pattern',
                                        label: (
                                          <>
                                            Russische Vorstösse{' '}
                                            <span>{TimeStringsKey[time]}</span>
                                          </>
                                        ),
                                        color:
                                          colorMode === 'light'
                                            ? '#C8C8D1'
                                            : 'rgba(239, 236, 224,.4)',
                                      },
                                    ]
                              }
                            />

                            <Source>
                              Quelle:{' '}
                              <a
                                href='https://acleddata.com/'
                                target={width < 712 ? '_self' : '_blank'}
                              >
                                ACLED
                              </a>
                              ,{' '}
                              <a
                                href='https://www.understandingwar.org/'
                                target={width < 712 ? '_self' : '_blank'}
                              >
                                ISW
                              </a>
                            </Source>
                          </KeyWrapper>
                        )}
                      </MapWrapper>
                    </Column>
                  </>
                )
              }}
            />
          </Column>
        </ContentGrid>
      }
    </AppContainer>
  )
}

const FrontElement = styled.div<{ distance?: number }>`
  text-align: left;
  background-color: var(--site-background);
  color: var(--text-color);
  font-size: 18px;
  padding: 30px;
  border-radius: 2px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-serif);
  line-height: 3rem;
  max-width: 606px;
  -webkit-box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);

  &.high {
    margin-top: 300px;
  }
  @media only screen and (max-width: 711px) {
    max-width: calc(100% + 1rem);
    width: calc(100% + 1rem);
    padding-right: 2rem;
    margin-left: -2rem;
    padding-left: 15px;
    padding-right: 15px;
  }
`

const Title = styled.div`
  font-family: var(--font-serif);
  font-size: 26px;
  color: var(--text-color);
  font-weight: 700;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 10px;
`

const KeyWrapper = styled.div`
  max-width: 666px;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex: 0 0 10%;
`
const AttackCounter = ({
  air,
  artillery,
  colorMode,
}: {
  air: number
  artillery: number
  colorMode: 'light' | 'dark'
}) => {
  return (
    <StyledAttackCounter>
      <AttackElement>
        <div className='icon'>
          <img
            src={require(colorMode === 'light'
              ? '../../assets/icons_artillery.png'
              : '../../assets/icons_artillery_dm.png')}
          />
        </div>
        <div className='value'> {artillery}</div>
        <div className='label'>Artillerie-, Raketenangriffe</div>
      </AttackElement>
      <AttackElement>
        <div className='icon'>
          <img
            src={require(colorMode === 'light'
              ? '../../assets/icons_air.png'
              : '../../assets/icons_air_dm.png')}
          />
        </div>
        <div className='value'>{air}</div>
        <div className='label'>Luftangriffe</div>
      </AttackElement>{' '}
    </StyledAttackCounter>
  )
}
const StyledAttackCounter = styled.div`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  font-family: var(--font-sans-serif);
  margin-bottom: 2em;
  color: var(--text-color);
  border-top: 1px solid #c8c8d1;
  padding-top: 2em;
  @media only screen and (max-width: 711px) {
    width: 100%;
  }
`
const StyledBuildingCounter = styled.div`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  font-family: var(--font-sans-serif);
  margin-bottom: 2em;
  color: var(--text-color);
  padding-top: 2em;
  @media only screen and (max-width: 711px) {
    width: 100%;
  }
`
const BuildingText = styled.div`
  flex: 0 0 100%;
  text-align: center;
  &.top {
    padding-bottom: 30px;
  }
  &.bottom {
    padding-top: 30px;
  }
`
const AttackElement = styled.div`
  flex: 0 0 50%;
  text-align: center;
  .icon {
    line-height: 0;
    img {
      max-width: 80px;
    }
  }
  .value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5em;
  }
  .label {
    font-size: 15px;
    line-height: 1.2em;
  }
`
const BuildingElement = styled.div`
  flex: 0 0 33%;
  text-align: center;
  .icon {
    line-height: 0;
    img {
      max-width: 100px;
      margin-bottom: 0.25em;
      @media only screen and (max-width: 711px) {
        max-width: 80px;
      }
    }
  }
  .value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5em;
  }
  .label {
    line-height: 1.2em;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
    }
  }
`
const OrangeMarker = styled.div<{ colorMode: 'light' | 'dark' }>`
  display: inline-block;
  width: 0.7em;
  height: 0.75em;
  border-radius: 0.75em;
  margin-left: 0.1em;
  margin-right: 0.1em;
  background-color: ${({ colorMode }) =>
    colorMode === 'light' ? '#e16d00' : '#e16d00'};
`
const BlueMarker = styled.div<{ colorMode: 'light' | 'dark' }>`
  display: inline-block;
  width: 0.75em;
  height: 0.75em;
  background-color: ${({ colorMode }) =>
    colorMode === 'light' ? '#202346' : '#69aacd'};
  border-radius: 0.75em;
  margin-left: 0.1em;
  margin-right: 0.1em;
`

const Time = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 26px;
  color: var(--text-color);
  font-weight: 300;
  padding-bottom: 2em;

  width: 100%;
  text-align: center;
  flex: 0 0 15%;
  @media only screen and (max-width: 711px) {
    font-size: 24px;
    padding-top: 30px;
  }
`
const TimeTitle = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 22px;
  color: var(--text-color);
  font-weight: 300;
  padding-bottom: 1em;
  font-family: var(--font-sans-serif);

  width: 100%;
  text-align: center;
  flex: 0 0 10%;
  @media only screen and (max-width: 711px) {
    font-size: 20px;
  }
`
const Source = styled.div`
  margin-top: 15px;
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  margin-bottom: 60px;
  @media only screen and (max-width: 711px) {
    margin-bottom: 30px;
    padding-left: 2rem;
  }
  a {
    color: var(--text-color);
  }
`
const MapWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (max-width: 711px) {
    /* width: 118%;
    margin-left: -9%; */
    max-width: 100vw;
    overflow: hidden;
    margin-left: -2rem;
    max-width: calc(100% + 4rem);
    width: calc(100% + 4rem);
  }
`
const AppContainer = styled(TamediaStyles)<{
  tenant?: string
}>`
  width: 100%;

  margin: 0;
  margin-top: 60px;
  margin-bottom: 60px;
  padding: 0;

  font-family: var(--font-sans-serif);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--site-background);
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
